import { useEffect, useRef, useState } from 'react'
import { Input, InputGroup } from 'reactstrap'

const InventoryCodeInput = ({
  value,
  onChange,
  placeholder = 'Masukkan kode inventori',
  maxSuggestions = 5,
  isAutoFocus = false,
  customStyleList,
}) => {
  const [suggestions, setSuggestions] = useState([])
  const [showDropdown, setShowDropdown] = useState(false)
  const inputRef = useRef(null)

  useEffect(() => {
    const storedCodes =
      JSON?.parse(localStorage?.getItem('lastInventoryCodes')) || []
    setSuggestions(storedCodes)
  }, [])

  const handleBlur = () => {
    setTimeout(() => setShowDropdown(false), 200)
    if (value?.trim()) {
      const newCode = value.trim()
      let storedCodes =
        JSON?.parse(localStorage?.getItem('lastInventoryCodes')) || []

      storedCodes = storedCodes?.filter((code) => code !== newCode)
      storedCodes?.unshift(newCode)
      if (storedCodes?.length > maxSuggestions) {
        storedCodes = storedCodes?.slice(0, maxSuggestions)
      }
      localStorage?.setItem('lastInventoryCodes', JSON.stringify(storedCodes))
    }
  }

  useEffect(() => {
    if (isAutoFocus && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus()
        setShowDropdown(true)
      }, 100)
    }
  }, [isAutoFocus])

  const handleFocus = () => {
    setShowDropdown(true)
  }

  const handleSelectSuggestion = (code) => {
    onChange(code)
    setShowDropdown(false)
  }

  return (
    <div style={{ position: 'relative' }}>
      <InputGroup className="mt-2">
        <Input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={handleBlur}
          onFocus={handleFocus}
          innerRef={inputRef}
          autoComplete="off"
          data-testid="inventory-code-input"
        />
      </InputGroup>

      {showDropdown && suggestions?.length > 0 && (
        <ul
          className="inventory-code-suggestions"
          style={{
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            ...customStyleList,
          }}
        >
          {suggestions?.map((suggestion, index) => (
            <li
              key={index}
              onMouseDown={() => handleSelectSuggestion(suggestion)}
              style={{
                padding: '12px',
                cursor: 'pointer',
              }}
            >
              {suggestion}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default InventoryCodeInput
